<template>
  <div
    :class="[
      $style.textInput,
      isFilled && $style.filled,
      error && $style.error,
      disabled && $style.disabled
    ]"
  >
    <input
      :id="id"
      v-cleave="{
        phone: true,
        phoneRegionCode: 'tw',
        onValueChanged,
      }"
      :class="$style.input"
      type="text"
      inputmode="tel"
      :disabled="disabled"
      :placeholder="placeholder"
      :value="value"
    >
    <transition name="slide-fade">
      <Error v-if="error">
        {{ error }}
      </Error>
    </transition>
  </div>
</template>

<script>
import Error from '../others/Error';

export default {
  components: {
    Error,
  },
  props: {
    id: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    value: {
      type: String,
      default: '',
    },
    error: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    isFilled() {
      return this.value && this.value.length > 0;
    },
  },

  methods: {
    onValueChanged(event) {
      this.$emit('update:value', event.target.rawValue);
    },
  },
};
</script>

<style lang="scss" module>
.input {
  font-size: 1.4rem;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  width: 100%;
  box-sizing: border-box;
  padding: 10px 16px;
  transition: 0.3s border-color;
  letter-spacing: 0.7px;
  color: $color-text;
  border: solid 1px #cfcfcf;
  border-radius: 5px;
  outline: none;
  background-color: transparent;
  caret-color: #e992a3;
  resize: vertical;

  &:disabled {
    opacity: 0.3;
  }

  &:focus {
    border-color: #eea2b1;
  }

  &:hover {
    border-color: #acacac;
  }

  .textInput.filled & {
    border-color: #acacac;

    &:focus {
      border-color: #eea2b1;
    }
  }

  .textInput.error & {
    border-color: $red;
    caret-color: $red;

    &:focus {
      border-color: $red;
      caret-color: $red;
    }
  }

  &::placeholder {
    font-size: 1.4rem;
    font-weight: 500;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: 0.6px;
    opacity: 0.23;
    color: $color-text;
  }
}
</style>
